import * as React from "react";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";

type ClassNames = "container" | "child";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        display: "flex",
        flex: 1,
        [theme.breakpoints.down("sm")]: {
            justifyContent: "center"
        }
    },
    child: {
        marginRight: theme.spacing.unit * 2
    }
});

interface RowListProps {
    noop?: boolean
}

class RowList extends React.Component<WithStyles<ClassNames> & RowListProps> {
    public render() {
        const {classes, children} = this.props;
        const count = React.Children.count(children);
        return (
            <div className={classes.container}>
                {
                    React.Children.map(children, (child, index) => (
                        child && (
                            <div className={(index + 1) !== count ? classes.child : undefined} key={index}>
                            {child}
                            </div>
                        )
                    ))
                }
            </div>
        );
    }
}

export default withStyles(styles)(RowList);



// WEBPACK FOOTER //
// ./src/components/RowList.tsx